<ng-container *ngIf="composant" class="treeEditor">
    <!-- Show Tree components for Edition -->
    <ng-container *ngIf="forEdition">
        <ul class="{{composant.children_type}}">
            <li *ngFor="let child of children" (click)="edit($event, child, composant)">
                <div class="liElt" *ngIf="shownId != child.id && !showAll">
                    <span *ngIf="child.validated">{{child.label}}</span>
                    <span *ngIf="!child.validated" class="toValidate">{{child.label}}</span>
                    <mat-icon aria-hidden="false" aria-label="Arrow right" class="editIcon"
                        (click)="show($event, child.id)" *ngIf="child.children_id.length > 0">
                        arrow_right
                    </mat-icon>
                    <mat-icon class="newChildIcon" (click)="newElement($event, child)" *ngIf="child.type!='Solution'">add_circle</mat-icon>
                    <hr />
                </div>
                <div class="liElt" *ngIf="shownId == child.id || showAll">
                    <span class="selectedText">{{child.label}}</span>
                    <mat-icon aria-hidden="false" aria-label="Arrow down" class="selected editIcon"
                        (click)="show($event, child.id)" *ngIf="child.children_id.length > 0">
                        arrow_drop_down
                    </mat-icon>
                    <mat-icon class="newChildIcon" (click)="newElement($event, child)">add_circle</mat-icon>
                    <hr />
                </div>
                <app-arbre-component [showAll]="showAll" [composant]="child" (reloadEvent)='emitReloadEvent()' [forEdition]=forEdition *ngIf="shownId == child.id || showAll">
                </app-arbre-component>
            </li>
        </ul>
    </ng-container>

    <!-- Show Tree components not for Edition -->

    <ng-container *ngIf="!forEdition">
        <ul class="{{composant.children_type}}">
            <li *ngFor="let child of children" (click)="selectComposant($event, child)">
                <div class="liElt" *ngIf="shownId != child.id">
                    <span>{{child.label}}</span>
                    <mat-icon aria-hidden="false" aria-label="Arrow right" (click)="show($event, child.id)"
                        *ngIf="child.children_id.length > 0">
                        arrow_right
                    </mat-icon>
                    <hr />
                </div>
                <div class="liElt" *ngIf="shownId == child.id">
                    <span class="selectedText">{{child.label}}</span>
                    <mat-icon aria-hidden="false" aria-label="Arrow down" (click)="show($event, child.id)"
                        *ngIf="child.children_id.length > 0">
                        arrow_drop_down
                    </mat-icon>
                    <hr />
                </div>
                <app-arbre-component [showAll]="showAll" [composant]="child" (composantEvent)='emitEvent(child)' [forEdition]=forEdition
                    *ngIf="shownId == child.id" (reloadEvent)=' emitReloadEvent()'></app-arbre-component>
            </li>
        </ul>
    </ng-container>
</ng-container>